import LocalizedStrings from "react-localization";

const strings = new LocalizedStrings({
    hu: {
        username: 'Felhasználónév',
        password: 'Jelszó',
        account: 'Felhasználói fiók',
        login: 'Belépés',
        logout: 'Kilépés',
        highlight: 'Kiemelés',
        highlights: 'Kiemelések',
        arrow: 'Nyíl',
        arrows: 'Nyilak',
        wall: 'Fal',
        walls: 'Falak',
        layer: 'Háttér',
        layers: 'Hátterek',
        index: 'Index',
        indexes: 'Indexek',
        undo: 'Vissza',
        redo: 'Előre',
        startPosition: 'Kezdő pozíció',
        clearBoard: 'Tábla törlése',
        flipBoard: 'Tábla elforgatása',
        savePosition: 'Aktuális pozíció mentése',
        loadPosition: 'Mentett pozíció betöltése',
        newPosition: 'Új pozíció',
        exportBoard: 'Tábla exportálása',
        exportAllPositions: 'Összes pozíció exportálása',
        shareSettings: 'Beállítások megosztása',
        saveTheme: 'Téma mentése',
        loadTheme: 'Téma betöltése',
        theme: 'Téma',
        position: 'Pozíció',
        extras: 'Extrák',
        piece: 'Bábu',
        table: 'Tábla',
        coordinates: 'Koordináták',
        pieceSize: 'Bábu méret',
        uniquePieceSize: 'Egyedi bábu méret',
        fullSize: 'Teljes méret',
        pattern: 'Minta',
        white: 'Fehér',
        black: 'Fekete',
        smallLetters: 'Kis betűk',
        capitalLetters: 'Nagy betűk',
        blackImages: 'Fekete képek',
        colorImages: 'Színes képek',
        hide: 'Elrejt',
        headline: 'Fejléc',
        description: 'Leírás',
        easy: 'Könnyű',
        hard: 'Nehéz',
        custom: 'Egyedi',
        positionNumber: 'Pozíció szám',
        whoCanWin: 'Ki nyer',
        toggleFigure: 'Jancsi bábu',
        resetPositionSettings: 'Pozíció beállítások törlése',
        color: 'Szín',
        type: 'Típus',
        size: 'Méret',
        radius: 'Sugár',
        opacity: 'Átlátszóság',
        location: 'Elhelyez-kedés',
        dashSize: 'Szaggatás méret',
        lineColor: 'Vonal szín',
        headColor: 'Fej szín',
        headOutlineColor: 'Fejkörvonal szín',
        lineSize: 'Vonal méret',
        headSize: 'Fej méret',
        normal: 'Normál',
        horse: 'L - ló',
        curvedTop: 'Görbe (fenn)',
        curvedBottom: 'Görbe (le)',
        curvedLeft: 'Görbe (bal)',
        curvedRight: 'Görbe (jobb)',
        under: 'Alatta',
        over: 'Felette',
        solid: 'Normál',
        dotted: 'Pontozott',
        dashed: 'Szaggatott',
        square: 'Négyzet',
        circle: 'Kör',
        category: 'Kategória',
        subcategory: 'Alkategória',
        positionName: 'Pozíció neve',
        save: 'Mentés',
        load: 'Betöltés',
        cancel: 'Mégse',
        close: 'Bezár',
        addCategory: 'Kategória hozzáadása',
        addSubcategory: 'Alkategória hozzáadása',
        editCategory: 'Kategória szerkesztése',
        deleteCategory: 'Kategória törlése',
        editCategories: 'Kategóriák szerkesztése',
        categoryName: 'Kategórianév',
        subcategoryName: 'Alkategórianév',
        categoryParent: 'Category parent',
        forMainCategory: 'Az alábbi főkategóriához:',
        rootCategory: 'Gyökér kategória',
        savePositionSuccess: 'A(z) [POSITION_NAME] pozíciót sikeresen elmentettük!',
        loadPositionSuccess: 'A(z) [POSITION_NAME] pozíciót sikeresen betöltöttük!',
        deletePositionSuccess: 'A(z) [POSITION_NAME] pozíciót töröltük!',
        choosePosition: 'Válassz pozíciót',
        positions: 'Pozíciók',
        chooseCategory: 'Válassz kategóriát',
        chooseSubcategory: 'Válassz alkategóriát',
        layout: 'Elrendezés',
        exportSelected: 'Kiválasztottak exportálása',
        exportPositions: 'Pozíciók exportálása',
        settingsCopiedSuccess: 'A beállításokat sikeresen vágólapra másoltuk!',
        customWidth: 'Egyedi szélesség',
        export: 'Exportálás',
        import: 'Importálás',
        fenImport: 'FEN importálás',
        fenExport: 'FEN exportálás',
        insertFen: 'Másold ide a FEN-t',
        exportFenSuccess: 'A FEN pozíciót vágólapra másoltuk!',
        themeName: 'Téma neve',
        moveUp: 'Felfele mozgat',
        moveDown: 'Lefele mozgat',
        editPosition: 'Pozíció szerkesztése',
        deletePosition: 'Pozíció törlése',
        chooseTheme: 'Válassz témát',
        saveThemeSuccess: 'A(z) [THEME_NAME] témát sikeresen elmentettük!',
        loadThemeSuccess: 'A(z) [THEME_NAME] témát sikeresen betöltöttük!',
        confirmDeleteCategory: 'Biztosan törölni akarod a(z) [CATEGORY_NAME] kategóriát?',
        confirmDeletePosition: 'Biztosan törölni akarod a(z) [POSITION_NAME] pozíciót?',
        missingPositionName: 'Adj a pozíciónak nevét!',
        missingPositionOrLayout: 'Válassz ki legalább 1 pozíciót és az elrendezést!',
        missingExportSize: 'Válaszd ki az exportálási méretet!',
        cannotDeleteMainCategoryError: "Fő kategóriák nem törölhetőek.\nElőször töröld az alkategóriákat.",
        cannotDeleteNonEmptyCategoryError: "A nem-üres kategóriák nem törölhetőek.\nElőször töröld/mozgatsd át a pozíciókat a kategóriából.",
        addIndexPrompt: "Add meg az index számot",
        deleteImage: 'Kép törlése',
        invalidLogin: 'Érvénytelen felhasználónév vagy jelszó!',
        loginSuccess: 'Sikeres belépés!',
        remainingCredits: 'Felhasználható kreditek',
        outOfCredit: 'Elfogytak a kreditjeid. Vegyél új krediteket az exportálás folytatásához.',
        buyCredits: 'Kreditek vásárlása',
        watermarkText: '© MINTA ! ©',
    },
    en:{
        username: 'Username',
        password: 'Password',
        account: 'Account',
        login: 'Login',
        logout: 'Logout',
        highlight: 'Highlight',
        highlights: 'Highlights',
        arrow: 'Arrow',
        arrows: 'Arrows',
        wall: 'Wall',
        walls: 'Walls',
        layer: 'Layer',
        layers: 'Layers',
        index: 'Index',
        indexes: 'Indexes',
        undo: 'Undo history',
        redo: 'Redo history',
        startPosition: 'Start position',
        clearBoard: 'Clear board',
        flipBoard: 'Flip board',
        savePosition: 'Save position',
        loadPosition: 'Load position',
        newPosition: 'New position',
        exportBoard: 'Export board',
        exportAllPositions: 'Export all positions',
        shareSettings: 'Share settings',
        saveTheme: 'Save Theme',
        loadTheme: 'Load Theme',
        theme: 'Theme',
        position: 'Position',
        extras: 'Extras',
        piece: 'Piece',
        table: 'Table',
        coordinates: 'Coordinates',
        pieceSize: 'Piece size',
        uniquePieceSize: 'Extra piece size',
        fullSize: 'Full size',
        pattern: 'Pattern',
        white: 'White',
        black: 'Black',
        smallLetters: 'Small letters',
        capitalLetters: 'Capital letters',
        blackImages: 'Black images',
        colorImages: 'Color images',
        hide: 'Hide',
        headline: 'Headline',
        description: 'Description',
        easy: 'Easy',
        hard: 'Hard',
        custom: 'Custom',
        positionNumber: 'Position number',
        whoCanWin: 'Who can win',
        toggleFigure: 'Toggle figure',
        resetPositionSettings: 'Reset position settings',
        color: 'Color',
        type: 'Type',
        size: 'Size',
        radius: 'Sugár',
        opacity: 'Opacity',
        location: 'Location',
        dashSize: 'Dash size',
        lineColor: 'Line color',
        headColor: 'Head color',
        headOutlineColor: 'Head outline color',
        lineSize: 'Line size',
        headSize: 'Head size',
        normal: 'Normal',
        horse: 'Horse',
        curvedTop: 'Curved (top)',
        curvedBottom: 'Curved (bottom)',
        curvedLeft: 'Curved (left)',
        curvedRight: 'Curved (right)',
        under: 'Under',
        over: 'Over',
        solid: 'Solid',
        dotted: 'Dotted',
        dashed: 'Dashed',
        square: 'Square',
        circle: 'Circle',
        category: 'Category',
        subcategory: 'Subcategory',
        positionName: 'Position name',
        save: 'Save',
        load: 'Load',
        cancel: 'Cancel',
        close: 'Close',
        addCategory: 'Add category',
        addSubcategory: 'Add subcategory',
        editCategory: 'Edit category',
        deleteCategory: 'Delete category',
        editCategories: 'Edit categories',
        categoryName: 'Category name',
        subcategoryName: 'Subcategory name',
        categoryParent: 'Category parent',
        forMainCategory: 'For main category',
        rootCategory: 'Root category',
        savePositionSuccess: 'Position setting [POSITION_NAME] has been saved!',
        loadPositionSuccess: 'Position [POSITION_NAME] has been loaded!',
        deletePositionSuccess: 'Position [POSITION_NAME] has been deleted!',
        choosePosition: 'Choose position',
        positions: 'Positions',
        chooseCategory: 'Choose category',
        chooseSubcategory: 'Choose subcategory',
        layout: 'Layout',
        exportSelected: 'Export selected',
        exportPositions: 'Pozíciók exportálása',
        settingsCopiedSuccess: 'Settings URL has been copied to clipboard!',
        customWidth: 'Custom width',
        export: 'Export',
        import: 'Import',
        fenImport: 'FEN import',
        fenExport: 'FEN export',
        insertFen: 'Insert the FEN string',
        exportFenSuccess: 'Position FEN has been exported to clipboard!',
        themeName: 'Theme name',
        moveUp: 'Move up',
        moveDown: 'Move down',
        editPosition: 'Edit position',
        deletePosition: 'Delete position',
        chooseTheme: 'Choose theme',
        saveThemeSuccess: 'Theme [THEME_NAME] has been saved!',
        loadThemeSuccess: 'Theme [THEME_NAME] has been loaded!',
        confirmDeleteCategory: 'Are you sure you want to delete category [CATEGORY_NAME]?',
        confirmDeletePosition: 'Are you sure you want to delete position [POSITION_NAME]?',
        missingPositionName: 'Add position name!',
        missingPositionOrLayout: 'Please select positions and layout!',
        missingExportSize: 'Select export size!',
        cannotDeleteMainCategoryError: "You cannot delete a main category.\nFirst remove the subcategories.",
        cannotDeleteNonEmptyCategoryError: "You cannot delete a not-empty category.\nFirst delete/move the positions from this category.",
        addIndexPrompt: "Please enter the index number",
        deleteImage: 'Delete image',
        invalidPassword: 'Invalid username or password!',
        loginSuccess: 'Login successful!',
        remainingCredits: 'Remaining credits',
        outOfCredit: 'You are out of export credits. Please upgrade your package to continue exporting.',
        buyCredits: 'Buy credits',
        watermarkText: '© SAMPLE ©',
    }
});

export default strings;



// WEBPACK FOOTER //
// ./src/Localization.js